export class ScheduleReleaseFilter {
  description!: string;
  building!: string[];
  floor!: string[];
  riser!: string[];
  room!: string[];
  tag!: string[];
  unscheduledOnly!: boolean;
}
